import { DEFAULT_FONT_SIZE } from '../../constants';

export default {
  container: {
    textAlign: 'center'
  },
  logoContainer: {
    width: 200,
    display: 'block',
    margin: 'auto'
  },
  header: {
    color: '#fff',
    display: 'none'
  },
  tag: {
    color: '#fff'
  },
  title: {
    color: '#fff',
    fontSize: DEFAULT_FONT_SIZE + 8,
    marginBottom: 60
  },
  input: {
    backgroundColor: '#fff',
    paddingLeft: '15px'
  },
  label: {
    fontColor: '#fff'
  }
};



// WEBPACK FOOTER //
// ./src/views/guest/Guest.styles.js